export const AUTH_TOKEN_KEY = 'token';
export const AUTH_REFRESH_TOKEN_KEY = 'refresh_token';

export const COOKIES_NAMES = {
  publishButtonTour: '_fd_publishbuttontour',
};
